import GameSection from './Section/GameSection';
import HeroSection from './Section/HeroSection';
import RankingSection from './Section/RankingSection';

export default function MiniGameContainer() {
  return (
    <div className="pb-football-page-bottom">
      <HeroSection />
      <GameSection />
      <RankingSection />
    </div>
  );
}
